<template>
  <div class="bg-white py-8 flex flex-col w-full items-center">
    <!--hijo-->
    <div class="flex flex-col w-full max-w-[76rem]">
      <h2 class="text-ROJO_LEON my-6 flex justify-center items-start font-bold text-lg md:text-2xl">
        <img class="h-4 md:h-7 mx-2 md:pt-1 mt-1" :src="'/img/shared/point-arrow-icon.webp'"
          alt="point-arrow-icon" />¿CÓMO FUNCIONA NUESTRA<br class="md:hidden" />
        COMPRA ONLINE?
      </h2>
      <div class="md:grid md:grid-cols-4 text-center m-auto gap-4">
        <div v-if="(isSmallScreen && currentSlider === 'slide-1') || !isSmallScreen" id="slide-1"
          class="relative rounded-md border border-GRIS_CLARO_BUSCAR_NEUMATICOS shadow-xl mx-auto py-8 px-3.5 group hover:bg-ROJO_LEON transition-colors duration-300">
          <span
            class="hidden md:flex text-white h-[40px] w-[40px] rounded-full bg-ROJO_LEON absolute mt-[-20px] ml-[-25px] group-hover:bg-GRIS_LEON transition duration-300 items-center justify-center group-hover:brightness-100"
            data-target="slide-1">
            1
          </span>
          <span
            class="hidden md:inline-flex justify-center items-center w-8 h-8 rounded-full bg-GRIS_CLARO_COMPLEMENTARIO absolute -right-4 top-1/2 -translate-y-1/2">
            <img class="h-[15px]" :src="'/img/shared/arrow-solid-right.webp'" alt="arrow-solid-right" />
          </span>
          <img id="img-slide-s" class="h-20 mx-auto transition duration-300 group-hover:invert group-hover:brightness-0"
            :src="'/img/home/busca-tu-neumatico-icon.webp'" alt="busca-tu-neumatico-icon" />
          <h3 class="font-bold m-3 text-ROJO_LEON mt-6 group-hover:text-white transition duration-300">
            BUSCA TU NEUMÁTICO
          </h3>
          <p class="group-hover:text-white transition duration-300">
            Busca tu auto o medida, te damos los datos del neumático adecuado según el fabricante.
            Indica tu ubicación y te dirigiremos al local más cercano.
          </p>
        </div>

        <div v-if="(isSmallScreen && currentSlider === 'slide-2') || !isSmallScreen" id="slide-2"
          class="relative rounded-md border border-GRIS_CLARO_BUSCAR_NEUMATICOS shadow-xl mx-auto py-8 px-3.5 md:block group group hover:bg-ROJO_LEON transition-colors duration-300">
          <span
            class="hidden md:flex text-white h-[40px] w-[40px] rounded-full bg-ROJO_LEON absolute mt-[-20px] ml-[-25px] group-hover:bg-GRIS_LEON transition-colors duration-300 items-center justify-center"
            data-target="slide-1">
            2
          </span>
          <span
            class="hidden md:inline-flex justify-center items-center w-8 h-8 rounded-full bg-GRIS_CLARO_COMPLEMENTARIO absolute -right-4 top-1/2 -translate-y-1/2">
            <img class="h-[15px]" :src="'/img/shared/arrow-solid-right.webp'" alt="arrow-solid-right" />
          </span>
          <img id="img-slide-2"
            class="h-20 mx-auto transition-colors duration-300 group-hover:invert group-hover:brightness-0"
            :src="'/img/home/selecciona-tu-neumatico-icon.webp'" alt="selecciona-tu-neumatico-icon" />
          <p class="font-bold m-3 text-ROJO_LEON mt-6 group-hover:text-white transition duration-300">
            SELECCIONA TU NEUMÁTICO
          </p>
          <p class="group-hover:text-white transition-colors duration-300">
            Te ofrecemos las mejores marcas del mercado. Si no sabes cuál elegir,
            te ayudamos con información técnica a través de audio e imágenes 360 como guía.
          </p>
        </div>
        <div v-if="(isSmallScreen && currentSlider === 'slide-3') || !isSmallScreen" id="slide-3"
          class="relative rounded-md border border-GRIS_CLARO_BUSCAR_NEUMATICOS shadow-xl mx-auto py-8 px-3.5 md:block group group hover:bg-ROJO_LEON transition-colors duration-300">
          <span
            class="hidden md:flex text-white h-[40px] w-[40px] rounded-full bg-ROJO_LEON absolute mt-[-20px] ml-[-25px] group-hover:bg-GRIS_LEON transition-colors duration-300 items-center justify-center"
            data-target="slide-1">
            3
          </span>
          <span
            class="hidden md:inline-flex justify-center items-center w-8 h-8 rounded-full bg-GRIS_CLARO_COMPLEMENTARIO absolute -right-4 top-1/2 -translate-y-1/2">
            <img class="h-[15px]" :src="'/img/shared/arrow-solid-right.webp'" alt="arrow-solid-right" />
          </span>
          <img id="img-slide-3"
            class="h-20 mx-auto transition-colors duration-300 group-hover:invert group-hover:brightness-0"
            :src="'/img/home/elige-la-modalidad-que-mas-te-acomoda-icon.webp'"
            alt="elige-la-modalidad-que-mas-te-acomoda-icon" />
          <h3 class="font-bold m-3 text-ROJO_LEON mt-6 group-hover:text-white transition-colors duration-300">
            MODALIDAD DE ATENCIÓN:
          </h3>

          <p class="group-hover:text-white transition-colors duration-300 text-left">
            Elige esperar, dejar o que retiremos tu vehículo para el servicio,
            y haremos que tu experiencia sea agradable en cada caso.
          </p>
        </div>
        <div v-if="(isSmallScreen && currentSlider === 'slide-4') || !isSmallScreen" id="slide-4"
          class="relative rounded-md border border-GRIS_CLARO_BUSCAR_NEUMATICOS shadow-xl mx-auto py-8 px-3.5 md:block group group hover:bg-ROJO_LEON transition-colors duration-300">
          <span
            class="hidden md:flex text-white h-[40px] w-[40px] rounded-full bg-ROJO_LEON absolute mt-[-20px] ml-[-25px] group-hover:bg-GRIS_LEON transition-colors duration-300 items-center justify-center"
            data-target="slide-1">
            4
          </span>
          <img id="img-slide-4"
            class="h-20 mx-auto transition-colors duration-300 group-hover:invert group-hover:brightness-0"
            :src="'/img/home/agenta-online-y-paga-en-tienda-icon.webp'"
            alt="elige-la-modalidad-que-mas-te-acomoda-icon" />
          <h3 class="font-bold m-3 text-ROJO_LEON mt-6 group-hover:text-white transition-colors duration-300">
            AGENDA ONLINE Y PAGA EN TIENDA
          </h3>

          <p class="group-hover:text-white transition-colors duration-300 text-left">
            Sabemos que comprar neumáticos puedes ser una tarea complicada.
            Es por eso, que puedes pagar online o en tienda una vez que esté realizado el servicio
            de instalación.
          </p>
        </div>
      </div>
      <div class="my-4 grid grid-cols-4 gap-2 md:hidden w-60 mx-auto">
        <button :class="currentSlider === 'slide-1' ? 'bg-ROJO_LEON' : 'bg-GRIS_LEON'" @click="showSlider('slide-1')"
          class="text-white text-xl h-[40px] w-[40px] rounded-full" data-target="slide-1">
          1
        </button>
        <button :class="currentSlider === 'slide-2' ? 'bg-ROJO_LEON' : 'bg-GRIS_LEON'" @click="showSlider('slide-2')"
          class="text-white text-xl h-[40px] w-[40px] rounded-full" data-target="slide-2">
          2
        </button>
        <button :class="currentSlider === 'slide-3' ? 'bg-ROJO_LEON' : 'bg-GRIS_LEON'" @click="showSlider('slide-3')"
          class="text-white text-xl h-[40px] w-[40px] rounded-full" data-target="slide-3">
          3
        </button>
        <button :class="currentSlider === 'slide-4' ? 'bg-ROJO_LEON' : 'bg-GRIS_LEON'" @click="showSlider('slide-4')"
          class="text-white text-xl h-[40px] w-[40px] rounded-full" data-target="slide-4">
          4
        </button>
      </div>
    </div>
  </div>

</template>

<script setup>
const currentSlider = ref("slide-1");

const showSlider = (sliderId) => {
  currentSlider.value = sliderId;
};

const isSmallScreen = ref(false);

const handleResize = () => {
  isSmallScreen.value = window.innerWidth <= 768;
};

const addEventListenerWindow = async () => {
  window.addEventListener("resize", handleResize);
};

const removeEventListenerWindow = async () => {
  window.removeEventListener("resize", handleResize);
};

onMounted(async () => {
  await addEventListenerWindow();
  handleResize();
});

onBeforeUnmount(async () => {
  await removeEventListenerWindow();
});
</script>

<style lang="scss" scoped></style>
